import { safeLocalStorage } from '@zealot/shared/browser';

export const SIGNED_OUT_PREFIX = 'signed_out_of:';

const signedOutKey = (brandUuid: string): string => `${SIGNED_OUT_PREFIX}${brandUuid}`;

// gloss
export const markBrandSignedOut = (brandUuid: string | null | undefined): void => {
  if (!brandUuid) return;
  safeLocalStorage.setItem(signedOutKey(brandUuid), '1');
};

export const isBrandSignedOut = (brandUuid: string | null | undefined): boolean =>
  !!brandUuid && safeLocalStorage.getItem(signedOutKey(brandUuid)) === '1';

export const clearBrandSignedOut = (brandUuid: string | null | undefined): void => {
  if (!brandUuid) return;
  safeLocalStorage.removeItem(signedOutKey(brandUuid));
};

// gloss
export const standingSignOutKeys = (): string[] => {
  if (typeof window === 'undefined') return [];

  const keys: string[] = [];
  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i);
    if (key?.startsWith(SIGNED_OUT_PREFIX)) keys.push(key);
  }

  return keys;
};

export const restoreStandingSignOuts = (keys: readonly string[]): void => {
  for (const key of keys) safeLocalStorage.setItem(key, '1');
};
